<ng-template #template>
  <div
    (click)="close()"
    class="gallery-container"
    (ngxResize)="onResize($event)"
    [style.--thumb-width]="thumbWidth() + 'px'"
    [style.--slider-width]="sliderWidth() + 'px'"
  >
    <div class="gallery-box">
      <div class="gallery-box-slider-container" (scrollend)="onScrollEnd($event)">
        <div class="gallery-box-slider">
          @for (item of items(); track item.uniqueIdentifier) {
            <div class="gallery-box-slider-item" #item #el (click)="$event.stopPropagation()">
              @if (item.type !== 3) {
                @if (item.type !== 2) {
                  <img
                    (load)="el.classList.add('loaded')"
                    loading="lazy"
                    [class.object-cover]="item.imagePreferCover"
                    [class.object-contain]="!item.imagePreferCover"
                    [style.object-position]="item.imageObjectPosition"
                    [src]="item.src | imageWidth: sliderWidth()"
                  />
                } @else {
                  <div class="gallery-box-iframe-container">
                    <iframe
                      (load)="el.classList.add('loaded')"
                      [src]="item.matterportUrl | safeUrl"
                      frameborder="0"
                      allowfullscreen
                      allow="autoplay; fullscreen; web-share; xr-spatial-tracking"
                    ></iframe>
                  </div>
                }
              } @else {
                <video controls [src]="item.src" (loadeddata)="el.classList.add('loaded')"></video>
              }
            </div>
          }
        </div>
      </div>
    </div>

    @if (items().length > 1) {
      <div class="gallery-items-slider">
        <div class="gallery-items-slider-content">
          @for (item of items(); track item.uniqueIdentifier) {
            <div
              class="gallery-items-slider-thumb"
              [class.selected]="item === openedItem()"
              (click)="selectImage(item, $event)"
              #thumb
            >
              @if (item.type !== 3) {
                @if (item.type === 2) {
                  <div class="gallery-items-slider-thumb-overlay">
                    <cue-icon [icon]="ICONS.cuePanorama" />
                    <span class="text">{{ translation.navigation.interactiveView | transloco }}</span>
                  </div>
                }
                <img
                  [src]="item.src | imageWidth: thumbWidth()"
                  [class.object-cover]="item.imagePreferCover"
                  loading="lazy"
                  [class.object-contain]="!item.imagePreferCover"
                  [style.object-position]="item.imageObjectPosition"
                />
              } @else {
                <video class="gallery-items-slider-thumb ring-offset-1" preload="metadata" [src]="item.src"></video>
                <div class="gallery-items-slider-thumb-overlay gallery-items-slider-thumb-overlay-video">
                  <cue-icon [icon]="ICONS.cuePlayFill" />
                </div>
              }
            </div>
          }
        </div>
      </div>
    }

    <div class="gallery-container-navigation">
      @if (items().length > 1) {
        <button (click)="moveLeft($event)" class="gallery-btn gallery-btn--prev">
          <cue-icon [icon]="ICONS.cueArrowLeft"></cue-icon>
        </button>
      }
      @if (items().length > 1) {
        <button (click)="moveRight($event)" class="gallery-btn gallery-btn--next">
          <cue-icon [icon]="ICONS.cueArrowRight"></cue-icon>
        </button>
      }
    </div>
    <button (click)="close()" class="gallery-close-btn gallery-btn">
      <cue-icon [icon]="ICONS.cueClose"></cue-icon>
    </button>
  </div>
</ng-template>
